import React from 'react';
import { StyleSheet, View } from 'react-native';
import { FontAwesome5 } from '@expo/vector-icons';
import { formalDimensions, pixelDimensions } from '../../config/utils';
import { appColors } from '../../assets/styles/global';
import { AppButton, AppText } from '../form';

export default function ButtonWithIcon({ icon, title, onPress }) {
  return (
    <AppButton primary disableDefaultColor style={styles.button} onPress={onPress}>
      <View style={styles.viewContainer}>
        <View style={styles.viewIconButton}>
          <FontAwesome5 name={icon} size={pixelDimensions(8)} color="#fff" />
        </View>
        <View style={styles.viewTextButton}>
          <AppText size="bold" style={styles.textButton}>{title}</AppText>
        </View>
      </View>
    </AppButton>
  );
}

const styles = StyleSheet.create({
  button: {
    backgroundColor: appColors.primary,
    borderRadius: pixelDimensions(4),
    padding: pixelDimensions(3),
    marginVertical: pixelDimensions(3.7),
    width: pixelDimensions(90),
    shadowColor: appColors.black,
    shadowOffset: {
      width: 0,
      height: 3,
    },
    shadowOpacity: 0.29,
    shadowRadius: 4.65,
    elevation: 7,
  },
  viewContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  viewIconButton: {
    borderRightWidth: 1,
    borderColor: appColors.white,
    alignSelf: 'center',
    alignItems: 'center',
    width: pixelDimensions(15),
    paddingRight: pixelDimensions(2),
  },
  viewTextButton: {
    flex: 1,
    paddingHorizontal: pixelDimensions(2),
  },
  textButton: {
    textAlign: 'center',
    color: appColors.white,
    fontSize: pixelDimensions(4.5),
    marginVertical: formalDimensions(2),
  },
});
